import { useDestination } from 'modules/campaigns/editor/hooks';
import { colors } from 'ui/theme/colors';
import { format, parseISO } from 'date-fns';

import {
  MESSAGE_MEDIUM_CONTENT_MAPPER,
  CAMPAIGN_TYPE_CONTENT_MAPPER,
  getIsTriggeredCampaignType,
} from 'modules/campaigns/lib/utils';
import { EmbeddedMessage } from 'constants/messageMediums';
import { useCampaignContext } from '../../../context';

import { getIsMediumWithDestination } from '../../../utils';
import { SampleApiRequestCodeBox } from '../AudienceSection';
import { JourneyLink } from '../JourneyLink';
import { SectionHeader, SectionWrapper } from '../Sections.styled';
import { JourneyNodeId } from '../JourneyNodeId';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

export const TYPE_SECTION_TEST_ID = 'type-section';

export const TypeSection = () => {
  const { campaign } = useCampaignContext();
  const { messageMedium, campaignTypeDefinition, journey, endedAt } = campaign;

  const { Icon: MessageMediumIcon, displayName: messageMediumDisplayName } =
    MESSAGE_MEDIUM_CONTENT_MAPPER[messageMedium];

  const { Icon: CampaignTypeIcon, displayName: campaignTypeDisplayName } =
    CAMPAIGN_TYPE_CONTENT_MAPPER[campaignTypeDefinition];

  // Destination field is only for in-app, push, embedded
  // We will update this to include embedded when it's ready
  const isMediumWithDestination = getIsMediumWithDestination(messageMedium);
  const { destinationType, destinationSelections } = useDestination(isMediumWithDestination);

  const isTriggeredCampaign = getIsTriggeredCampaignType(campaignTypeDefinition);
  const isEmbeddedCampaign = messageMedium === EmbeddedMessage;

  return (
    <SectionWrapper data-test={TYPE_SECTION_TEST_ID}>
      <SectionHeader>Type</SectionHeader>

      <CampaignFormField labelText="Medium">
        <ReadOnlyField name="messageMedium">
          <MessageMediumIcon color={colors.grey50} data-test={`${messageMedium}-icon`} />
          {messageMediumDisplayName}
        </ReadOnlyField>
      </CampaignFormField>

      {/* Destination field is only for in-app, push, embedded */}
      {isMediumWithDestination && (
        <CampaignFormField labelText="Destination">
          <ReadOnlyField name="destination">{destinationType}</ReadOnlyField>
          {destinationSelections}
        </CampaignFormField>
      )}

      <CampaignFormField labelText="Type">
        <ReadOnlyField name="campaignTypeDefinition">
          <CampaignTypeIcon color={colors.grey50} data-test={`${campaignTypeDefinition}-icon`} />
          {campaignTypeDisplayName}
        </ReadOnlyField>
      </CampaignFormField>

      {journey && (
        <CampaignFormField labelText="Associated journey">
          <ReadOnlyField name="associatedJourney">
            <JourneyLink journey={journey} />
          </ReadOnlyField>
          <JourneyNodeId journey={journey} campaignId={campaign.id} />
        </CampaignFormField>
      )}

      {isTriggeredCampaign && endedAt && (
        <CampaignFormField labelText="Campaign Ended At">
          <ReadOnlyField name="endedAt">
            {format(parseISO(endedAt), 'EEEE, MMMM do yyyy, h:mm a')}
          </ReadOnlyField>
        </CampaignFormField>
      )}

      {isTriggeredCampaign && !isEmbeddedCampaign && (
        <CampaignFormField labelText="Sample API request">
          <SampleApiRequestCodeBox />
        </CampaignFormField>
      )}
    </SectionWrapper>
  );
};
